export const environment = {
  production: true,
  apiBaseUrl: "https://wickedlist.com",
  name: "PRODUCTION"
};
